// src/hooks/useDrawerObserver.js
import { useEffect, useState } from 'react';

const useDrawerObserver = (drawerClassName) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    const drawerElement = document.querySelector(`.mainMenuSideNav`);

    if (!drawerElement) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isMainMenu = drawerElement.classList.contains('mainMenuSideNav'); // Adjust according to the class that indicates the Drawer is open
          const isOpenMenu = drawerElement.classList.contains('show-menu'); // Adjust according to the class that indicates the Drawer is open

          if (isMainMenu && isOpenMenu) {
            setIsDrawerOpen(true);
          } else {
            setIsDrawerOpen(false);
          }
        }
      });
    });

    observer.observe(drawerElement, { attributes: true });

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, [drawerClassName]);

  return isDrawerOpen;
};

export default useDrawerObserver;
